import React from "react";
import { enforceMaxLength } from "../../helpers/enforceMaxLength";
import ErrorHandler from "../ErrorHandler/ErrorHandler.component";
import { renderBadge } from "./helpers";

const CustomInputField = ({
  type,
  name,
  placeholder,
  reference,
  label,
  errors,
  maxLength,
  max,
  defaultValue,
  minLength,
  onChange,
  iconType,
  readOnly,
  isShowBadge = false,
  badgeText = null,
}) => {
  return (
    <div className="mb-5">
      {!isShowBadge && <label className="label-txt">{label}</label>}
      {isShowBadge && (
        <label className="label-txt d-flex justify-content-between">
          <span className="d-block">{label}</span>
          {badgeText && renderBadge(badgeText)}
        </label>
      )}
      <div className="form-group inputWithIcon">
        <input
          className="user__form form-control"
          type={type}
          name={name}
          max={max}
          placeholder={placeholder}
          ref={reference}
          onKeyPress={enforceMaxLength}
          maxLength={maxLength}
          minLength={minLength}
          defaultValue={defaultValue}
          onChange={onChange}
          readOnly={readOnly}
        />
        <i className={iconType} />
      </div>
      <div className="text-left mb-2 ml-3" style={{ marginTop: "-10px" }}>
        <ErrorHandler errors={errors} />
      </div>
    </div>
  );
};

export default CustomInputField;
